var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5218 21C15.3909 21.0006 15.2611 20.9736 15.1402 20.9204C15.0193 20.8672 14.9096 20.789 14.8176 20.6903L8.17383 13.6516C8.04132 13.4462 7.98153 13.1978 8.00499 12.9503C8.02845 12.7028 8.13366 12.472 8.30207 12.2986C8.47048 12.1252 8.69127 12.0204 8.92549 12.0027C9.15971 11.9849 9.39233 12.0554 9.5823 12.2016L15.5218 18.452L21.4613 12.2016C21.6486 12.073 21.8712 12.0147 22.0935 12.036C22.3158 12.0574 22.5249 12.1573 22.6873 12.3195C22.8497 12.4818 22.9559 12.6972 22.989 12.931C23.0221 13.1649 22.9801 13.4038 22.8698 13.6094L16.226 20.6481C16.1374 20.7544 16.0293 20.8405 15.9082 20.901C15.7871 20.9615 15.6556 20.9952 15.5218 21Z",
    fill: "#675D75"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDown);
export default __webpack_public_path__ + "static/media/ChevronDown.516d94e4d99caa4b9723f8be5807f2e9.svg";
export { ForwardRef as ReactComponent };